import { __awaiter, __generator } from "tslib";
import { IDLE_LOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import getSerpVersion from './getSerpVersion';
/**
 * Loading of the Search modules in one of two ways, depending on a flight:
 * 1. Through search-page-bootstrapper
 * 2. Legacy way of importing directly from dist packages
 */
export function loadModules(options) {
    return __awaiter(this, void 0, void 0, function () {
        var searchPageModule;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBootstrappedSearchModules(options)];
                case 1:
                    searchPageModule = _a.sent();
                    preloadBootstrapperModules(searchPageModule);
                    return [2 /*return*/, searchPageModule];
            }
        });
    });
}
/**
 * Preload the search bootstrapper modules and keep ready
 */
function preloadBootstrapperModules(searchPageModule) {
    var _this = this;
    scheduleWork(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            searchPageModule.loadPrefetch();
            searchPageModule.loadSearchDispatcher();
            searchPageModule.loadSearchInstrumentation();
            searchPageModule.loadStrings();
            return [2 /*return*/];
        });
    }); }, IDLE_LOW_PRIORITY);
}
/**
 * Search Page Bootstrapper fetching of the searchPageModule
 */
export function getBootstrappedSearchModules(options) {
    return __awaiter(this, void 0, void 0, function () {
        var bootstrapperModule, hostAppId, cdnOptions, isPayForPlayEnabled, microsoftSearchBootstrapperUrlOverridesEnabled, microsoftSearchBootstrapperKillSwitchesActive, loadingPattern, searchPageModule;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(
                    /* webpackChunkName: 'search-page-bootstrapper' */ '@1js/search-page-bootstrapper')];
                case 1:
                    bootstrapperModule = _a.sent();
                    hostAppId = options.hostAppId, cdnOptions = options.cdnOptions, isPayForPlayEnabled = options.isPayForPlayEnabled, microsoftSearchBootstrapperUrlOverridesEnabled = options.microsoftSearchBootstrapperUrlOverridesEnabled, microsoftSearchBootstrapperKillSwitchesActive = options.microsoftSearchBootstrapperKillSwitchesActive;
                    loadingPattern = isPayForPlayEnabled ? 'standBy' : 'deepLink';
                    return [4 /*yield*/, bootstrapperModule.loadSearchPage({
                            loadingPattern: loadingPattern,
                            cdnOptions: cdnOptions,
                            hostAppId: hostAppId,
                            preferredVersion: getSerpVersion(microsoftSearchBootstrapperKillSwitchesActive),
                            isUrlOverridingEnabled: microsoftSearchBootstrapperUrlOverridesEnabled,
                        })];
                case 2:
                    searchPageModule = _a.sent();
                    return [2 /*return*/, Promise.resolve(searchPageModule)];
            }
        });
    });
}
//# sourceMappingURL=Bootstrapper.js.map